export const Reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export const getItemStyle = (isDragging, draggableStyle) => ({
  ...draggableStyle,
});

/* eslint-disable-next-line no-unused-vars */
export const getItemListStyle = (isDraggingOver) => ({});

/* eslint-disable-next-line no-unused-vars */
export const getAnswerListStyle = (isDraggingOver) => ({
  border: 0,
});
